var i = Object.defineProperty;
var a = (n, t, o) => t in n ? i(n, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : n[t] = o;
var e = (n, t, o) => a(n, typeof t != "symbol" ? t + "" : t, o);
const w = class w {
  /**
   * Returns the derived environment for a given location string
   *
   * @param locationHref The fullly qualified URL to derive the environment from
   * @returns the active environment for the given URL, with the production environment returning 'prod'
   */
  static getEnvironmentForLocation(t) {
    var r;
    const o = ((r = w.ENV_RE.exec(t)) == null ? void 0 : r[1]) ?? "www";
    return o === "www" ? "prod" : o;
  }
  /**
   * Retrieves the current environment based on the window object.
   *
   * If no window exists (e.g. server-side rendering), returns an empty string
   */
  static get currentEnvironment() {
    return window ? w.getEnvironmentForLocation(window.location.href) : "";
  }
};
e(w, "ENV_RE", /(\w+)(?:\.www)?\.service\.vic\.gov\.au/);
let c = w;
export {
  c as EnvironmentService
};
